import { createFileRoute } from '@tanstack/react-router';
import { FundingDetailsStepForm } from './-components/project-new-steps/funding-details-step';

export const Route = createFileRoute('/ngos/projects/new/funding-details')({
	component: FundingDetailsStepForm,
});
